import qz from "qz-tray";
import { AppDispatch } from "../../../store/store";
import {
  setConnectionState,
  setPrinters,
  setSelectedPrinter,
} from "../../../store/slices/qztray/qzTrayClientSlice";

/**
 * 🖨️ Lógica para descubrir impresoras usando QZ Tray + Firma Digital Backend
 */
export const discoverPrintersLogic = async (
  dispatch: AppDispatch,
  config: any,
  handle: (err: any) => void,
  showAlert: (type: string, title: string, msg: string) => void,
  sign: (toSign: string) => Promise<string>,
  isConnectedFromStore?: boolean
): Promise<string[]> => {
  try {
    const cert = config?.certificateContent?.trim();

    if (!cert) {
      throw new Error("No se recibió el certificado público requerido por QZ Tray.");
    }

    // ======================================================
    // 🔐 Certificado público
    // ======================================================
    qz.security.setCertificatePromise((resolve, reject) => {
      try {
        resolve(cert);
      } catch (error) {
        reject(error);
      }
    });

    // ======================================================
    // ✍️ Firma remota SHA256
    // ======================================================
    qz.security.setSignatureAlgorithm("SHA256");

    qz.security.setSignaturePromise((toSign) => {
      return (resolve, reject) => {
        sign(toSign)
          .then((signature) => {
            if (!signature || typeof signature !== "string") {
              reject("El backend no devolvió una firma válida.");
              return;
            }

            resolve(signature);
          })
          .catch((error) => {
            console.error("❌ Error firmando desde backend:", error);
            reject(error);
          });
      };
    });

    // ======================================================
    // 🔌 Conexión QZ Tray
    // ======================================================
    const alreadyConnected = isConnectedFromStore || qz.websocket.isActive();

    if (!alreadyConnected) {
      const { host, port, sslEnabled } = config;
      const protocol = sslEnabled ? "wss" : "ws";
      const endpoint = `${protocol}://${host}:${port}`;

      await qz.websocket.connect({ address: endpoint });

      dispatch(
        setConnectionState({
          isConnected: true,
          endpoint,
        })
      );
    }

    // ======================================================
    // 🖨️ Detectar impresoras
    // ======================================================
    const printers = await qz.printers.find();

    if (!printers?.length) {
      showAlert(
        "warning",
        "Sin impresoras",
        "No se encontró ninguna impresora instalada."
      );

      return [];
    }

    dispatch(setPrinters(printers));

    const saved = localStorage.getItem("qzPrinter");

    dispatch(
      setSelectedPrinter(
        saved && printers.includes(saved) ? saved : printers[0]
      )
    );

    showAlert(
      "success",
      "Impresoras detectadas",
      `${printers.length} encontradas`
    );

    return printers;
  } catch (err: any) {
    console.error("❌ Error descubriendo impresoras:", err);

    handle(err);

    showAlert(
      "error",
      "Error al buscar impresoras",
      err?.message || "No fue posible detectar impresoras."
    );

    dispatch(
      setConnectionState({
        isConnected: false,
        endpoint: null,
      })
    );

    return [];
  }
};